import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import {API_BASE_URL} from '../../utils/paths';

export const sendContactSupport = createAsyncThunk(
  'contactSupport/send',
  async (contactData, { rejectWithValue }) => {
    try {
      const response = await fetch(`${API_BASE_URL}/contact-support`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(contactData),
      });

      const data = await response.json();

      if (!response.ok) {
        return rejectWithValue(data);
      }

      return data;
    } catch (error) {
      return rejectWithValue({ message: error.message });
    }
  }
);

const contactSupportSlice = createSlice({
  name: 'contactSupport',
  initialState: {
    loading: false,
    error: null,
    errors: {},
    success: null,
  },
  reducers: {
    clearMessages: (state) => {
      state.error = null;
      state.errors = {};
      state.success = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(sendContactSupport.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.errors = {};
        state.success = null;
      })
      .addCase(sendContactSupport.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        state.errors = {};
        state.success = action.payload?.message || 'Your message has been sent successfully.';
      })
      .addCase(sendContactSupport.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || 'Failed to send your message';
        state.errors = action.payload?.errors || {};
      });
  },
});

export const { clearMessages } = contactSupportSlice.actions;
export default contactSupportSlice.reducer;
